module.exports = __webpack_public_path__ + "img/selected2-min.25cf380e.png";